import React from 'react';
import './Button.css';

export function Button({
  children,
  variant = 'primary',
  size = 'default',
  icon,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}) {
  const classes = [
    'button',
    `button-${variant}`,
    `button-${size}`,
    fullWidth && 'button-full',
    loading && 'button-loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {loading && <span className="button-spinner" />}
      {!loading && icon && iconPosition === 'left' && (
        <span className="button-icon">{icon}</span>
      )}
      <span className="button-text">{children}</span>
      {!loading && icon && iconPosition === 'right' && (
        <span className="button-icon">{icon}</span>
      )}
    </button>
  );
}

export default Button;
